import React from 'react'

export default function IconCancel() {
  return (
    <svg className="block h-full w-full" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.01074 22.9906L16.0014 16L22.9921 22.9906M22.9921 9.00931L16.0001 16L9.01074 9.00931" stroke="currentcolor" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
